import { Box } from "@mui/material";
import { Grid } from "@mui/system";
import { type FC, type ReactNode } from "react";

import { InsightsSidebar } from "~/feature/insights/components/InsightsSidebar/InsightsSidebar";
import type { IInsightsSidebarData } from "~/feature/insights/types";

interface InsightsSidebarLayoutProps {
  sidebar: IInsightsSidebarData;
  children: ReactNode;
}

/** Mobile Filters accordion above content; desktop sticky sidebar to the left. */
export const InsightsSidebarLayout: FC<InsightsSidebarLayoutProps> = ({
  sidebar,
  children,
}) => {
  return (
    <>
      <Box sx={{ display: { xs: "block", md: "none" }, width: "100%", mb: 2 }}>
        <InsightsSidebar data={sidebar} variant="mobile" />
      </Box>

      <Grid container spacing={3} sx={{ width: "100%" }}>
        <Grid size={{ md: 3 }} sx={{ display: { xs: "none", md: "block" } }}>
          <InsightsSidebar data={sidebar} variant="desktop" />
        </Grid>
        <Grid size={{ xs: 12, md: 9 }}>{children}</Grid>
      </Grid>
    </>
  );
};
